import $http from '@/utils/fetch'

const getUserShopCoupon = data => {
  return $http.post('user/shop-coupon/new-list', data)
}

const getUserLotteryList = data => {
  return $http.post('user/shop-coupon/lottery/list', data)
}

const getUserCouponInfo = data => {
  return $http.post('user/shop-coupon/info', data)
}

const getShopCouponInfo = data => {
  return $http.post('shop-coupon/info', data)
}

const getLotteryAddress = data => {
  return $http.post('lottery/address', data)
}

const lotteryOrderInfo = data => {
  return $http.post('lottery/order/info', data)
}

const postExchangeCode = data => {
  return $http.post('shop-coupon/exchange/code', data)
}

const getLotteryAnnouncement = data => {
  return $http.post('lottery/announcement/list', data)
}

const postLotteryAutoOrder = data => {
  return $http.post('lottery/auto/order', data)
}

const getLotteryBindInfo = data => {
  return $http.post('lottery/bind/info', data)
}

const getLotteryBindBank = data => {
  return $http.post('lottery/bind/bank', data)
}

const postLotteryDoBindBank = data => {
  return $http.post('lottery/do/bind/bank', data)
}

export default {
  getUserShopCoupon,
  getUserLotteryList,
  getUserCouponInfo,
  getShopCouponInfo,
  getLotteryAddress,
  lotteryOrderInfo,
  postExchangeCode,
  getLotteryAnnouncement,
  postLotteryAutoOrder,
  getLotteryBindInfo,
  getLotteryBindBank,
  postLotteryDoBindBank
}
